<div role="group" [attr.aria-labelledby]="'flight-row-group-' + idx">
  <div class="flex justify-between items-end">
    <h4 class="b" [id]="'flight-row-group-' + idx">
      {{ content?.bookMessages?.multicity?.flight }} {{ idx + 1 }}
    </h4>
    <jb-action
      actionIcon="removeElement"
      (click)="removeRow(idx)"
      *ngIf="idx > 1"
    >
      {{ content?.bookMessages?.multicity?.removeFlight }}
    </jb-action>
  </div>
  <div class="w-100 flex flex-column mt1 flex-row-ns">
    <dot-city-pair-selector
      class="db w-100 w-two-thirds-ns"
      [content]="content?.citySelector"
      [showShortCityName]="content?.showShortCityName === 'true'"
      [recentAirports]="recentAirports || {}"
      [origins]="origins$ | async"
      [origin]="fromAirport.value"
      [destination]="toAirport.value"
      [destinations]="destinations$ | async"
      [separatePartnerCities]="separatePartnerCities"
      [showValidationErrors]="
        showValidationErrors && idx > 1
          ? fromAirport.value || toAirport.value || departure.value
          : showValidationErrors
      "
      [swappable]="true"
      [formWrapper]="formWrapper"
      (originChange)="handleOriginChange($event)"
      (destinationChange)="handleDestinationChange($event)"
      (userChangedOrigin)="handleOriginChange($event)"
      (userChangedDestination)="handleDestinationChange($event)"
    >
    </dot-city-pair-selector>
    <jb-date-picker
      class="w-100 w-third-ns plo pl1-ns pt1 pt0-ns"
      [calendarLabelDone]="
        content.dateAggregator.doneLabel
          ? content.dateAggregator.doneLabel
          : 'Done'
      "
      [calendarLabelReset]="
        content.dateAggregator.resetLabel
          ? content.dateAggregator.resetLabel
          : 'Reset'
      "
      [closeOnDateSelected]="!(content?.keepCalendarOpen === 'true')"
      [dateFormat]="displayFormat"
      [defaultDate]="minDate$ | async"
      [minDate]="minDate$ | async"
      [maxDate]="maxDate"
      [shouldFlipVertically]="false"
    >
      <jb-form-field-container>
        <jb-date-picker-input
          #jbDatePickerInput
          class="bg-white"
          [ngClass]="{
            'jb-invalid': showValidationErrors && departure.errors
          }"
          [label]="content?.dateAggregator.departureLabel"
          [formControl]="departure"
          [dateInputFormats]="customDateInputFormats"
          (valueChange)="dateValueChanged($event)"
        >
        </jb-date-picker-input>
        <jb-error
          [showErrorIf]="showValidationErrors && departure.errors"
          aria-live="polite"
        >
          <span aria-hidden="true">{{
            departure.errors && getErrorMessage(departure.errors)
          }}</span>
          <jb-sr-only
            >Error:
            {{
              departure.errors && getErrorMessage(departure.errors)
            }}</jb-sr-only
          >
        </jb-error>
      </jb-form-field-container>
      <jb-calendar-legal-message>{{
        seasonalRouteMessage
      }}</jb-calendar-legal-message>
      <jb-calendar-legal-message
        >{{ scheduleExtensionMsg }}
        {{ maxDate | jbDate: 'MMM d, yyyy' }}.</jb-calendar-legal-message
      >
    </jb-date-picker>
  </div>
</div>
